module.exports = __webpack_public_path__ + "media/KikiJ.662d07ec.mp3";